module.exports = __webpack_public_path__ + "r-v3/img/line.1ca330a0.svg";